import { Controller } from "@hotwired/stimulus"

// Rendered inside reports#new (loaded into the :report turbo frame). Captures
// the offscreen Chart.js canvases as PNGs and auto-submits the form to
// reports#create. The user has already confirmed on the previous button, so no
// further interaction is required.
export default class extends Controller {
  static targets = ["topPartiesChart", "topStakeholdersChart", "histogram", "fileInput", "form"]

  connect() {
    // Give Chart.js a moment to finish rendering before capturing the canvases.
    setTimeout(() => this.generateChartImagesAndSubmit(), 500)
  }

  generateChartImagesAndSubmit() {
    Promise.all([
      this.generateChartImage(this.topPartiesChartTarget, "top_parties_chart.png", "top_parties_chart"),
      this.generateChartImage(this.topStakeholdersChartTarget, "top_stakeholders_chart.png", "top_stakeholders_chart"),
      this.generateChartImage(this.histogramTarget, "histogram.png", "histogram")
    ]).then(() => this.formTarget.requestSubmit())
  }

  generateChartImage(canvas, filename, fieldName) {
    return new Promise(resolve => {
      if (!canvas) {
        resolve()
        return
      }

      canvas.toBlob(blob => {
        if (blob) {
          const file = new File([blob], filename, { type: "image/png" })
          const fileInput = this.fileInputTargets.find(input => input.name.includes(fieldName))
          if (fileInput) {
            const dataTransfer = new DataTransfer()
            dataTransfer.items.add(file)
            fileInput.files = dataTransfer.files
          }
        }
        resolve()
      }, "image/png", 1.0)
    })
  }
}
